import { render, staticRenderFns } from "./OnSaleToResellers.vue?vue&type=template&id=7bc7a202&"
import script from "./OnSaleToResellers.vue?vue&type=script&lang=js&"
export * from "./OnSaleToResellers.vue?vue&type=script&lang=js&"
import style0 from "./OnSaleToResellers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OnSaleToResellers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports